import React, { Fragment } from 'react';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import HomeLayout from "../../../containers/HomeLayout";
import * as actions from '../../../store/actions/messageActions';
import * as profileActions from '../../../store/actions/profileActions';
import heartbeat from '../../../assets/img/home/heartbeat.svg';

import '../../../assets/css/chat.css';

const InterestedPeople = () => {
    const messageState = useSelector(state => state.message);
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();

    const getAge = (userDob) => {
        var dob = new Date(userDob);
        var age = (new Date().getFullYear()) - dob.getFullYear();

        return age;
    }

    const unmatchCouple = (coupleId) => {
        dispatch(actions.unmatchCouple(coupleId, profileState.userProfile.profileId));
    }

    const renderReplyBlock = () => {
        var profileReplyBlocks = messageState.interestedInYou.map((couple, i) => {
            var matchedProfile = {};
            if (couple.firstMoveProfileId === profileState.userProfile.profileId) {
                matchedProfile = profileState.profiles.filter(x => x.profileId === couple.secondMoveProfileId)[0];
            }
            else {
                matchedProfile = profileState.profiles.filter(x => x.profileId === couple.firstMoveProfileId)[0];
            }

            return (
                <div className="reply-block" key={i}>
                    <div className="preview-text">
                        <div>
                            {matchedProfile.profilePrompts.length > 0 ? 
                                <Fragment>
                                    <p className="prompt-preview">You should leave a message if</p>
                                    <p className="response-preview">
                                        {matchedProfile.profilePrompts[0].promptContent}
                                    </p>
                                </Fragment> : null
                            }
                        </div>
                        <div><button className="uni-btn" onClick={() => unmatchCouple(couple.coupleId)}>Unmatch</button></div>
                    </div>
                        
                    <Link to={`/conversations/messages/${matchedProfile.profileName}`} style={{textDecoration: 'none', width: '100%'}}>
                        <div className="match-reply">
                            <h2 className="match-name-age">{matchedProfile.profileName}, {getAge(matchedProfile.dateOfBirth)}</h2>
                        </div>
                    </Link>
                </div>
            )
        });

        return profileReplyBlocks;
    }

    useEffect(() => {
        dispatch(profileActions.fetchProfiles(profileState.userProfile.profileId))
            .then(() => {
                dispatch(actions.fetchCouples(profileState.userProfile.profileId));
            });
    }, []);

    return (
        <HomeLayout>
            <div className="pref-button-row">
                <a href="#">
                    <i className="fa fa-sliders-h"></i>
                </a>
            </div>

            <div className="content-row">

                <div className="content-title">
                    <h1>Interested In You</h1>
                    <h4>Make your move</h4>
                </div>

                <div className="content-blocks">
                    {renderReplyBlock()}
                </div>

            </div>
        </HomeLayout>
    );
}

export default InterestedPeople;